<!-- slider Area Start -->
<div class="slider-area position-relative" *ngIf="router.url === '/home'">
  <div class="slider-active">
    <div class="single-slider slider-height d-flex align-items-center slider-dynamic"
      [ngClass]="{'slide-trigoria': currentSlide === 0}"
      [ngStyle]="{'background-image': 'url(' + slides[currentSlide].bg + ')'}">

      <div class="bg-overlay"></div>
      <div class="container position-relative">
        <div class="video-icon">
          <a class="popup-video btn-icon" (click)="openVideoModal()">
            <i class="fas fa-play"></i>
          </a>
        </div>

        <!-- Freccia sinistra -->
        <button class="slider-arrow slider-arrow-left" (click)="prevSlide($event)">
          <i class="fas fa-chevron-left"></i>
        </button>

        <!-- Freccia destra -->
        <button class="slider-arrow slider-arrow-right" (click)="nextSlide($event)">
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- slider Area End -->

<!-- Modal video -->
<div class="video-modal" *ngIf="showVideoModal">
  <div class="video-modal-backdrop" (click)="closeVideoModal()"></div>
  <div class="video-modal-content">
    <button class="close-btn" (click)="closeVideoModal()">✖</button>
    <video #videoPlayer width="100%" height="auto" controls autoplay [muted]="isMuted" [src]="videos[currentIndex]">
    </video>
  </div>
</div>